/* =========================================================
   Meta klik-id i kurven (spec 2026-10-16, Del B1).
   Med marketing-samtykke skrives skjulte cart attributes, som portalen
   læser fra ordrens note_attributes (Del C):
     _fbp            = Meta-cookien _fbp (hvis den findes)
     _fbc            = Meta-cookien _fbc / fb.1.<ms>.<fbclid> fra URL'en (se pickFbc)
     _meta_samtykke  = 'ja'
   Uden samtykke skrives intet, og trækkes samtykket tilbage, sættes de til ''.
   Kun disse tre nøgler røres; andre attributes (Kort-vælgeren, Pakning m.fl.) lades i fred.
   Skrivning sker først, når ingen andre kurv-mutationer er i gang (+600 ms ro).
   Kerne (ren logik) = window.MTWMetaKlik i browseren, module.exports i Node
   (tests/meta-klik-id.test.cjs). Browser-delen kører kun med et document.
   ========================================================= */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MTWMetaKlik = api;
  if (typeof document !== 'undefined' && typeof window !== 'undefined') api.start(window, document);
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var KEYS = ['_fbp', '_fbc', '_meta_samtykke'];
  var BLANK = { _fbp: '', _fbc: '', _meta_samtykke: '' };
  var SS_FBC = 'mtw_meta_fbc';
  // STALE_MS: en kurv-request, der ikke er afsluttet efter 15 s, blokerer ikke længere (fx en hængende postAdd).
  var QUIET_MS = 600, RETRY_MS = 2000, STALE_MS = 15000;
  // Metas format er fb.<subdomæne-indeks>.<ms>.<værdi>[.<appendiks>]; tjekket er bevidst lempeligt.
  var FBP_RE = /^fb\.\d\.\d{10,16}\.[A-Za-z0-9_.\-]{1,100}$/;
  var FBC_RE = /^fb\.\d\.\d{10,16}\.[A-Za-z0-9_.\-]{1,600}$/;
  var FBCLID_RE = /^[A-Za-z0-9_\-]{1,500}$/;
  var MUT_RE = /\/cart\/(add|update|change|clear)(?:\.js)?(?:[?#]|$)/;

  function str(v) { return typeof v === 'string' ? v : ''; }

  function readCookie(cookieStr, name) {
    var parts = str(cookieStr).split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].replace(/^\s+/, '');
      if (p.indexOf(name + '=') === 0) {
        var raw = p.slice(name.length + 1);
        try { return decodeURIComponent(raw); } catch (e) { return raw; }
      }
    }
    return '';
  }

  // Bannerets cookie mtw_consent = {"statistik":bool,"marketing":bool,"v":<version>}.
  // Kun et eksplicit ja i den gældende version tæller (version = window.mtwConsentVersion).
  function cookieMarketing(cookieStr, version) {
    var raw = readCookie(cookieStr, 'mtw_consent');
    if (!raw || typeof version !== 'number') return false;
    try { var c = JSON.parse(raw); return !!c && c.marketing === true && c.v === version; } catch (e) { return false; }
  }

  // api = Shopify.customerPrivacy.marketingAllowed() eller 'na', hvis API'et ikke er indlæst.
  // -> true (skriv), false (fjern), null (ved ikke: hverken skriv eller fjern).
  // Et eksplicit nej fra Shopify (fx GPC) vinder over cookien; et svar der ikke er true/false = ved ikke.
  function allowed(cookieStr, api, version) {
    if (api !== 'na' && api !== true && api !== false) return null;
    if (!cookieMarketing(cookieStr, version)) return false;
    return api !== false;
  }

  function fbclidFrom(search) {
    var m = /[?&]fbclid=([^&#]*)/.exec(str(search));
    if (!m) return '';
    var v;
    try { v = decodeURIComponent(m[1]); } catch (e) { return ''; }
    return FBCLID_RE.test(v) ? v : '';
  }

  function fbcFor(fbclid, nowMs) { return 'fb.1.' + Math.floor(nowMs) + '.' + fbclid; }
  function fbcMs(v) { return +(v.split('.')[2]) || 0; }
  function endsWithClick(v, fbclid) { return v.slice(-(fbclid.length + 1)) === '.' + fbclid; }

  // Hvilken _fbc gælder nu?
  // - fbclid i URL'en: cookien, hvis den allerede er for det fbclid; ellers den gemte, hvis den er;
  //   ellers en ny fb.1.<nu>.<fbclid> (det nyeste klik vinder).
  // - intet fbclid: den nyeste (største <ms>) af cookie og gemt.
  function pickFbc(fbcCookie, fbclid, storedFbc, nowMs) {
    var cookie = FBC_RE.test(str(fbcCookie)) ? fbcCookie : '';
    var stored = FBC_RE.test(str(storedFbc)) ? storedFbc : '';
    if (fbclid) {
      if (cookie && endsWithClick(cookie, fbclid)) return cookie;
      if (stored && endsWithClick(stored, fbclid)) return stored;
      return fbcFor(fbclid, nowMs);
    }
    if (cookie && stored) return fbcMs(stored) > fbcMs(cookie) ? stored : cookie;
    return cookie || stored;
  }

  // Ønskede værdier med samtykke. Tom kilde = behold det, kurven har (blankes kun ved tilbagetrækning).
  function wanted(src) {
    var fbp = FBP_RE.test(str(src.fbp)) ? src.fbp : '';
    return { _fbp: fbp, _fbc: str(src.fbc), _meta_samtykke: 'ja' };
  }

  // Patch med kun de nøgler, der skal ændres; null = intet at skrive.
  function patchFor(current, want) {
    var cur = current || {}, out = null;
    KEYS.forEach(function (k) {
      var w = str(want[k]);
      if (!w) return;
      if (str(cur[k]) !== w) { out = out || {}; out[k] = w; }
    });
    return out;
  }

  // Patch der fjerner vores nøgler (værdi ''), men kun dem kurven har.
  function removalFor(current) {
    var cur = current || {}, out = null;
    KEYS.forEach(function (k) { if (str(cur[k])) { out = out || {}; out[k] = ''; } });
    return out;
  }

  function pick(attrs) {
    var a = attrs || {}, out = {};
    KEYS.forEach(function (k) { out[k] = str(a[k]); });
    return out;
  }

  // Hvad skal sendes? o = {
  //   allowed: true|false|null, cookieYes: mtw_consent siger ja i gældende version,
  //   force: kunden har lige trukket samtykket tilbage i banneret, add: add-to-cart er lykkedes,
  //   user: kunden har lige givet samtykke i banneret, attrs: kurvens værdier eller null (ukendt),
  //   n: antal varer, hasCart: der findes en kurv (cart-cookien), want: wanted(...) }
  function decide(o) {
    var known = !!o.attrs;
    // Eksplicit tilbagetrækning: fjern alt uanset snapshot (det kan være forældet), men opret ikke en kurv.
    if (o.force && !o.cookieYes) return (o.hasCart || o.n > 0 || removalFor(o.attrs)) ? copy(BLANK) : null;
    if (o.allowed === null) return null;
    if (o.allowed === false) return known ? removalFor(o.attrs) : null;
    var go = o.add || (o.n > 0 && (known || o.user));
    return go ? patchFor(known ? o.attrs : {}, o.want) : null;
  }
  function copy(o) { var r = {}; for (var k in o) r[k] = o[k]; return r; }

  // 'add' | 'update' | 'change' | 'clear' | ''
  function mutationOf(input) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || String(input || ''); } catch (e) { return ''; }
    var m = MUT_RE.exec(url);
    return m ? m[1] : '';
  }
  function isAddUrl(input) { return mutationOf(input) === 'add'; }

  /* ---------- browser ---------- */
  function start(win, doc) {
    if (win.__mtwMetaKlik) return;
    win.__mtwMetaKlik = true;

    var state = { n: 0, attrs: null };
    try {
      var snap = JSON.parse((doc.getElementById('mtw-meta-cart') || {}).textContent || 'null');
      if (snap) { state.n = +snap.n || 0; state.attrs = pick(snap.a); }
    } catch (e) {}

    var origFetch = typeof win.fetch === 'function' ? win.fetch : null;
    if (!origFetch) return;
    var flying = [], timer = null, pend = {}, retried = false;
    function now() { return (win.Date || Date).now(); }

    function ss(fn) { try { return fn(win.sessionStorage); } catch (e) { return ''; } }
    function apiState() {
      try {
        var cp = win.Shopify && win.Shopify.customerPrivacy;
        return cp && typeof cp.marketingAllowed === 'function' ? cp.marketingAllowed() : 'na';
      } catch (e) { return 'na'; }
    }
    function hasPend() { for (var k in pend) return true; return false; }
    function arm(ms) { if (timer) clearTimeout(timer); timer = setTimeout(run, ms || QUIET_MS); }
    // Igangværende kurv-mutationer; poster ældre end STALE_MS tæller ikke.
    function busy() { var t = now(); flying = flying.filter(function (x) { return t - x < STALE_MS; }); return flying.length > 0; }
    function request(flags) { for (var k in flags) if (flags[k]) pend[k] = true; arm(); }
    function begin() { var tok = now(); flying.push(tok); return tok; }
    function end(tok) { var i = flying.indexOf(tok); if (i >= 0) flying.splice(i, 1); if (hasPend()) arm(); }

    function run() {
      timer = null;
      if (!hasPend()) return;
      if (busy()) { arm(); return; } // kurven er ikke i ro: prøv igen om lidt (end() nulstiller også)
      var f = pend; pend = {};
      var cookie = doc.cookie, ver = win.mtwConsentVersion;
      var a = allowed(cookie, apiState(), ver);
      var cookieYes = cookieMarketing(cookie, ver);
      var fbc = '';
      if (a === true) {
        fbc = pickFbc(readCookie(cookie, '_fbc'), fbclidFrom(win.location.search),
          ss(function (s) { return s.getItem(SS_FBC); }), Date.now());
        if (fbc) ss(function (s) { s.setItem(SS_FBC, fbc); });
      } else if (a === false || (f.force && !cookieYes)) {
        ss(function (s) { s.removeItem(SS_FBC); });
      }
      var patch = decide({
        allowed: a, cookieYes: cookieYes, force: !!f.force, add: !!f.add, user: !!f.user,
        attrs: state.attrs, n: state.n, hasCart: /(?:^|;\s*)cart=/.test(cookie),
        want: wanted({ fbp: readCookie(cookie, '_fbp'), fbc: fbc })
      });
      if (patch) send(patch, f);
    }

    function send(patch, f) {
      var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
      var tok = begin();
      origFetch.call(win, root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: patch })
      }).then(function (r) {
        if (r.ok) return r.json().then(function (cart) { retried = false; fromCart(cart); });
        if ((r.status === 429 || r.status >= 500) && !retried) {
          retried = true; // ét nyt forsøg efter ~2 s
          setTimeout(function () { request(f); }, RETRY_MS - QUIET_MS);
        }
      }).catch(function () {}).then(function () { end(tok); });
    }

    function fromCart(cart) {
      if (cart && cart.attributes && typeof cart.item_count === 'number') {
        state.attrs = pick(cart.attributes); state.n = cart.item_count;
      }
    }

    // Én global lytter på alle kurv-mutationer (product-form, cart.js, Kort-vælgeren, upsell, Pakning ...).
    // Kaldets eget løfte returneres urørt; vi tæller kun igangværende mutationer og hænger en sidegren på.
    win.fetch = function (input) {
      var p = origFetch.apply(win, arguments);
      var kind = mutationOf(input);
      if (kind) {
        var tok = begin();
        p.then(function (r) {
          if (r && r.ok) {
            if (kind === 'add') { state.n = Math.max(state.n, 1); pend.add = true; }
            else { try { r.clone().json().then(fromCart, function () {}); } catch (e) {} }
          }
          end(tok);
        }, function () { end(tok); });
      }
      return p;
    };

    // Samtykke ændret. 'user' = kunden har lige valgt i banneret; 'restore' = gemt valg ved sideindlæsning.
    doc.addEventListener('mtw:consent', function (e) {
      var d = (e && e.detail) || {};
      if (d.source === 'user') request(d.marketing ? { user: true } : { force: true });
      else request({ consent: true });
    });
    doc.addEventListener('visitorConsentCollected', function () { request({ consent: true }); });

    // Gendannet fra bfcache: snapshot'et kan være forældet -> ukendt, til næste add/svar.
    win.addEventListener('pageshow', function (e) { if (e && e.persisted) state.attrs = null; });
    // Siden forlades: send en ventende skrivning/fjernelse straks (keepalive bærer den videre).
    win.addEventListener('pagehide', function () {
      if (!hasPend() || busy()) return;
      if (timer) { clearTimeout(timer); timer = null; }
      run();
    });

    request({ load: true });
  }

  return {
    KEYS: KEYS, readCookie: readCookie, cookieMarketing: cookieMarketing, allowed: allowed,
    fbclidFrom: fbclidFrom, fbcFor: fbcFor, pickFbc: pickFbc, wanted: wanted, decide: decide,
    patchFor: patchFor, removalFor: removalFor, pick: pick, mutationOf: mutationOf, isAddUrl: isAddUrl,
    start: start
  };
});
